import React from "react";
import ReactApexChart from "react-apexcharts";
import { getNiceMax } from "../utils/chartDataUtils";
import MemberBreakdownList from "./MemberBreakdownList";

const SOURCE_LABELS = {
  CSV_IMPORT: "CSV Import",
  LIST_BUILDER: "List Builder",
  CONNECTED_CRM: "Connected CRM",
  LINKEDIN_SALES_NAVIGATOR: "LinkedIn Sales Navigator",
  LINKEDIN_PLUGIN_PURCHASE: "LinkedIn Plugin Purchase"
};

// SG-2164: Contacts Added, broken down by source. Ships 5 of 6 sources — "Single Contact Upload"
// is excluded (no distinguishing backend signal exists), see Z_tasks/SG-2164-new-widgets-requirements.md.
// Line chart with the x-axis hidden — 5 long source names (e.g. "LinkedIn Sales Navigator") never
// fit legibly under bars/ticks at small-to-medium widget widths, so the source name is surfaced
// via the point tooltip on hover instead of a fixed axis label.
const ContactsAddedWidget = ({ total, trend, contactsAddedBreakdown = [], memberBreakdown }) => {
  if (!contactsAddedBreakdown.length) {
    return <p className="contactsAddedEmpty">No contacts added data</p>;
  }

  const labels = contactsAddedBreakdown.map(s => SOURCE_LABELS[s.source] || s.source);
  const counts = contactsAddedBreakdown.map(s => s.count);
  const { max: niceMax, tickAmount } = getNiceMax(Math.max(...counts, 1));

  const options = {
    chart: {
      // "area" (not "line") so the connecting line renders reliably — matches RateWidget/CountWidget.
      type: "area",
      toolbar: { show: false },
      animations: { enabled: false },
      selection: { enabled: false },
      zoom: { enabled: false }
    },
    stroke: { curve: "smooth", width: 2 },
    markers: {
      size: 4,
      colors: ["#3953fb"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: { size: 5 }
    },
    fill: { type: "solid", opacity: 0.2 },
    colors: ["#3953fb"],
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: labels,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      tooltip: { enabled: false }
    },
    yaxis: {
      min: 0,
      max: niceMax,
      tickAmount,
      // Hidden to match the count/rate widgets — values are surfaced via the point tooltip on hover.
      labels: { show: false }
    },
    grid: {
      borderColor: "#e8ebee",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } }
    },
    tooltip: {
      x: { show: true },
      y: { formatter: val => `${val} contacts` }
    }
  };

  const series = [{ name: "Contacts Added", data: counts }];

  return (
    <div className="contactsAddedWrap">
      {total != null && (
        <div className="contactsAddedTotalRow">
          <span className="contactsAddedTotalValue">{total}</span>
          {trend && (
            <span className={`contactsAddedTrend ${trend.direction}`}>
              {trend.direction === "up" ? "▲" : trend.direction === "down" ? "▼" : ""} {trend.percent}%
            </span>
          )}
        </div>
      )}
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={160}
        width="100%"
      />
      <MemberBreakdownList rows={memberBreakdown} />
    </div>
  );
};

export default ContactsAddedWidget;
